module.exports = __webpack_public_path__ + "static/media/fairill.f106c1e0.png";